/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.83"
        height="19"
        viewBox="0 0 18.83 19"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M0 19h13.8v-5.5l4.56-3.53a1.07 1.07 0 0 0 .46-.74 1.12 1.12 0 0 0-.26-.84l-1-1.37a1.12 1.12 0 0 0-.73-.47 1.09 1.09 0 0 0-.86.26l-2.13 1.65V5.22L8.66.07H.08ZM16.56 7.55h.07a.2.2 0 0 1 .09.09l1.05 1.37.06.1-.09.08-5 3.88-1.73 1.35-1.88.16.68-1.74ZM8.87 1.7l3.29 3.27H8.87ZM1 1h6.87v5h4.92v3.23l-3.72 2.89-.11.09-1.36 3.48 3.72-.31 1.43-1.11v3.75H.95Zm5 10.86-1.38 1.39-1.43-1.39-.71.71 1.38 1.39-1.38 1.39.71.71 1.38-1.39 1.38 1.39.71-.71-1.39-1.39 1.39-1.39-.71-.71Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'PaperFoldedCornerWithXAndPencilIcon';

export default Icon;
